import Button from 'components/Button'
import Input from 'components/Input'
import Label from 'components/Label'
import { ChangePasswordWrapper } from './styled'
import { useFormik } from 'formik'
import * as Yup from "yup"
import { REGEX_PASSWORD } from 'constants/regex'
import { authError } from 'errors/auth'
import { useDispatch, useSelector } from "react-redux"
import { authAction } from "redux/slice/authSlice"
import { authSelector } from 'redux/selector'
import ShowToast from 'utils/ShowToast'
import Loading from 'components/Loading'

const ChangePassword = () => {
    const dispatch = useDispatch()
    const authState = useSelector(authSelector)
    const formData = useFormik({
        initialValues: {
            current_password: "",
            new_password: "",
            password_confirmation: "",
        },
        validateOnBlur: false,
        validateOnChange: false,
        validationSchema: Yup.object({
            current_password: Yup.string().trim().required(authError.requiredPassword).matches(REGEX_PASSWORD, authError.invalidPassword),
            new_password: Yup.string().trim().required(authError.requiredNewPassword).matches(REGEX_PASSWORD, authError.invalidPassword),
            password_confirmation: Yup.string().trim().required(authError.requiredPasswordConfirm).oneOf(
                [Yup.ref("new_password"), null],
                authError.invalidPasswordConfirm
            )
        }),
        onSubmit: (values, { setFieldError }) => {
            if (!authState.isFetching) {
                dispatch(authAction.changePassword({ data: values, setFieldError, callBack }))
            }
        }
    })

    function callBack() {
        formData.setValues({
            current_password: "",
            new_password: "",
            password_confirmation: "",
        })
        formData.setErrors({})
        ShowToast("success", "Đổi mật khẩu thành công")
    }
    return (
        <ChangePasswordWrapper className='bg-grey2  p-15 '>
            <h1 className="text-black s-18 bb-grey-1 pb-5">Đổi mật khẩu</h1>
            <div className='flex-center py-50'>
                <form onSubmit={formData.handleSubmit}>
                    <Label className="mb-10" >Mật khẩu cũ</Label>
                    <Input
                        type='password'
                        name="current_password"
                        id="current_password"
                        isError={formData.errors.current_password}
                        value={formData.values.current_password}
                        message={formData.errors.current_password}
                        onChange={formData.handleChange}
                    />
                    <Label className="mb-10 mt-25">Mật khẩu mới</Label>
                    <Input
                        type='password'
                        name="new_password"
                        id="new_password"
                        isError={formData.errors.new_password}
                        message={formData.errors.new_password}
                        value={formData.values.new_password}
                        onChange={formData.handleChange}
                    />
                    <Label className="mb-10 mt-25">Xác nhận mật khẩu</Label>
                    <Input
                        type='password'
                        name="password_confirmation"
                        id="password_confirmation"
                        isError={formData.errors.password_confirmation}
                        value={formData.values.password_confirmation}
                        message={formData.errors.password_confirmation}
                        onChange={formData.handleChange}
                    />
                    <Button className="mt-50 action-danger-1" type="submit" isNa={authState.isFetching}>Đổi mật khẩu</Button>
                </form>
                {
                    authState.isFetching && <Loading />
                }
            </div>

        </ChangePasswordWrapper>
    )
}

export default ChangePassword